<form class="search-form" [formGroup]="searchForm">
  <mat-form-field class="w-full">
    <input
      matInput
      google-place
      placeholder="Search address..."
      [formControlName]="'address'"
      (onSelectParts)="setAddressParts($event)"
      autocomplete="none"
    />
  </mat-form-field>
  <mat-checkbox class="px-2 py-1 rounded" [color]="'primary'" [formControlName]="'flood_map'"> Flood Map </mat-checkbox>
</form>
<section class="w-full h-full">
  <mgl-map
    [style]="'mapbox://styles/mapbox/satellite-streets-v11'"
    [zoom]="[15]"
    [minZoom]="4"
    [projection]="'mercator'"
    [center]="[center.longitude, center.latitude]"
    (mapLoad)="map = $event"
    (load)="onMapLoad($event)"
    [transformRequest]="onTransformMapRequest"
    (mapClick)="onMapClick($event)"
  >
    <mgl-vector-source id="parcels" [tiles]="[parceledTileServerUrl + '/app/api/tiles/parcels/{z}/{x}/{y}']">
    </mgl-vector-source>
    <mgl-image [id]="item.id" [url]="item.descriptionImage" *ngFor="let item of floodMapOverlayImages"> </mgl-image>

    <ng-container *ngIf="!properties.length && showPin">
      <mgl-marker [lngLat]="[center.longitude, center.latitude]">
        <img src="assets/images/map/red-marker.png" style="width: 24px" />
      </mgl-marker>
    </ng-container>

    <ng-container *ngFor="let parcel of selectedParcels">
      <ng-container *ngIf="parcel && parcel.lat && parcel.lng">
        <mgl-marker
          [lngLat]="[parcel.lng, parcel.lat]"
          *ngIf="parcel.lng !== center.longitude && parcel.lat !== center.latitude"
        >
          <img src="assets/images/map/orange-dot.png" />
        </mgl-marker>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="properties.length && showPin">
      <ng-container *ngFor="let property of properties; let i = index">
        <mgl-marker [lngLat]="[property?.address?.longitude, property?.address?.latitude]">
          <div class="marker" (mouseenter)="onPopupOpen(i)" (mouseleave)="onPopupClose(i)">
            <img src="assets/images/map/red-marker.png" />
          </div>
        </mgl-marker>
        <ng-container *ngIf="popupStates[i]">
          <mgl-popup
            [closeOnClick]="false"
            [closeButton]="false"
            [lngLat]="[property?.address?.longitude, property?.address?.latitude]"
            [offset]="[0, -12]"
          >
            <span class="popup-title">{{ property.name || property.address_string }}</span>
          </mgl-popup>
        </ng-container>
      </ng-container>
    </ng-container>
    <mgl-control mglFullscreen></mgl-control>

    <mgl-control>
      <div [hidden]="!fullScreenMode"><app-flood-map-legend></app-flood-map-legend></div>
    </mgl-control>

    <mgl-layer
      id="parcels-line"
      source="parcels"
      sourceLayer="parcels_aa26ac80_shp"
      type="line"
      [layout]="{
        visibility: parcelTilesVisible,
      }"
      [paint]="{
        'line-color': '#e2e8f0',
      }"
    ></mgl-layer>
    <mgl-layer
      id="parcels-fill"
      source="parcels"
      sourceLayer="parcels_aa26ac80_shp"
      type="fill"
      (layerClick)="onParcelClick($event)"
      (layerMouseEnter)="onParcelLayerMouseMove()"
      (layerMouseLeave)="onParcelLayerMouseLeave()"
      [layout]="{
        visibility: 'visible',
      }"
      [paint]="{
        'fill-color': '#627BC1',
        'fill-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 0.7, 0],
      }"
    ></mgl-layer>
    <ng-container *ngIf="showFloodMap">
      <mgl-vector-source
        type="vector"
        id="flood_zones"
        [tiles]="[parceledTileServerUrl + '/app/api/tiles/flood_zones/{z}/{x}/{y}']"
        [minzoom]="8"
      ></mgl-vector-source>
      <mgl-layer
        id="flood_zones-fill"
        source="flood_zones"
        sourceLayer="fema_flood_hazard_areas_10_09_24"
        type="fill"
        [layout]="{ visibility: 'visible' }"
        [paint]="layerFlood"
      ></mgl-layer>
    </ng-container>
  </mgl-map>
</section>
